import React, {
  ElementType,
  PropsWithChildren,
  ReactNode,
  useMemo,
} from "react";
import { ILink } from "../../ActionsSelectors/Link";

export interface IBulletListItemProps<T = Record<string, unknown>> {
  /** Link (if there is one) */
  link?: ILink;
  /** You can pass a custom tag for inner content (for example, a NavLink, etc.) */
  customTag?: ElementType;
  /** Text / content of the item */
  children?: ReactNode;
}

function BulletListItem<T = Record<string, unknown>>({
  link,
  customTag,
  children,
  ...rest
}: PropsWithChildren<IBulletListItemProps<T>>) {
  const Tag = useMemo(() => {
    if (customTag) return customTag;
    return link?.href ? "a" : "span";
  }, [customTag, link]);
  return (
    <li>
      <Tag {...link} {...rest}>
        {children}
      </Tag>
    </li>
  );
}

export default BulletListItem;
